import "@zeg/ui/global.css";
import {App} from "@zeg/webui";
import {StrictMode} from "react";
import ReactDOM from "react-dom/client";

if (typeof document !== "undefined") {
  const rootElement = document.getElementById("root");
  if (rootElement && !rootElement.innerHTML) {
    // Check if rootElement exists
    const root = ReactDOM.createRoot(rootElement);
    root.render(
      <StrictMode>
        <App />
      </StrictMode>
    );
  }
}
